/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  RispondenteDTO,
  RispondenteRequest,
  WsProblema,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ritorna l'elenco dei rispondenti.
 * @deprecated
 * @summary (Test FE) Elenco Rispondenti
 */
export const getFrontRispondenti = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RispondenteDTO[]>(
    { url: `/framework-cmp-domande/rispondenti`, method: 'get', signal },
    options,
  );
};

export const getGetFrontRispondentiQueryKey = () =>
  [`/framework-cmp-domande/rispondenti`] as const;

export const getGetFrontRispondentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRispondenti>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontRispondenti>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRispondenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFrontRispondentiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRispondenti>>
  > = ({ signal }) => getFrontRispondenti(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontRispondentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRispondenti>>
>;
export type GetFrontRispondentiQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary (Test FE) Elenco Rispondenti
 */
export const useGetFrontRispondenti = <
  TData = Awaited<ReturnType<typeof getFrontRispondenti>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontRispondenti>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRispondentiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea un nuovo rispondente.
 * @deprecated
 * @summary (Test FE) Crea Rispondente
 */
export const postFrontRispondenti = (
  rispondenteRequest: RispondenteRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<RispondenteDTO>(
    {
      url: `/framework-cmp-domande/rispondenti`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: rispondenteRequest,
    },
    options,
  );
};

export const getPostFrontRispondentiMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRispondenti>>,
    TError,
    { data: RispondenteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRispondenti>>,
  TError,
  { data: RispondenteRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRispondenti>>,
    { data: RispondenteRequest }
  > = props => {
    const { data } = props ?? {};

    return postFrontRispondenti(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRispondentiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRispondenti>>
>;
export type PostFrontRispondentiMutationBody = RispondenteRequest;
export type PostFrontRispondentiMutationError = ErrorType<WsProblema>;

/**
 * @deprecated
 * @summary (Test FE) Crea Rispondente
 */
export const usePostFrontRispondenti = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRispondenti>>,
    TError,
    { data: RispondenteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostFrontRispondentiMutationOptions(options);

  return useMutation(mutationOptions);
};
